<template>
    <ModalWrapper v-model="isShowModal">
        <template v-slot:title>
            {{ $t('product.info.create_program') }}
        </template>
        <template v-slot:content>
            <v-form ref="form" v-model="valid" data-cy="guest-category-form">
                <div class="pb-4">
                    <LocaleSwitcher @change="changeActiveLangCode" />
                </div>
                <TextFieldLocale
                    v-model="program.name[activeLangCode]"
                    :label="`${$t('name')}*`"
                    :active-lang-code="activeLangCode"
                    data-cy="name"
                    :rules="[requiredRule('name')]"
                    hide-details
                />
            </v-form>
        </template>
        <template v-slot:btns>
            <v-btn data-cy="save" :disabled="isLoading || !valid" variant="flat" @click="save">
                {{ $t('save') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script setup lang="ts">
    import {requiredRule} from '~/composables/rules'
    import TextFieldLocale from '~/components/TextFieldLocale.vue'

    const emit = defineEmits<{
        (e: 'save'): void
    }>()

    const isShowModal = defineModel<boolean>({
        default: false,
    })

    const app = useNuxtApp()
    const {t} = useI18n()

    const valid = ref<boolean>(false)
    const isLoading = ref<boolean>(false)
    const activeLangCode = ref<string>('en')
    const program = ref({name: {}})

    const save = async (): Promise<void> => {
        try {
            isLoading.value = true
            await app.$api.packagePrograms.post({
                ...program.value,
            })
            app.$toast.success(t('success_message.saved_successfully'))
            program.value = {name: {}}
            emit('save')
        } catch (e) {
            app.$toast.error(t('error_message.save_error'))
        } finally {
            isLoading.value = false
        }
    }

    const changeActiveLangCode = (code: string): void => {
        activeLangCode.value = code
    }
</script>
